// eslint-disable-next-line
export default new (class FaqModel {
  // static API_URL = process.env.REACT_APP_API_URL;

  async get(data) {
    const model = {};

    model.id = data.id || 0;
    model.question = data.Question || [];
    model.answer = data.Answer[0] || [];

    return model;
  }
})();
